import { html, LitElement, nothing } from 'lit';
import { customElement, property } from 'lit/decorators.js';
import { unsafeSVG } from 'lit/directives/unsafe-svg.js';
import Styles from './vm-icon.scss';

const iconModules = import.meta.glob<string>('./assets/ic-*.svg', {
    query: '?raw',
    import: 'default',
    eager: true,
});

export const iconNames = [
    'alert-triangle',
    'arrow-narrow-left',
    'arrow-narrow-right',
    'arrow-narrow-up-right',
    'arrow-up',
    'attachment-02',
    'award-03',
    'calendar',
    'check',
    'check-circle',
    'check-circle-solid',
    'chevron-down',
    'chevron-left',
    'chevron-right',
    'edit-05',
    'external-link',
    'file-06',
    'image-03',
    'link-01',
    'linkedin',
    'loading',
    'mail-01',
    'message-square-02',
    'play',
    'plus',
    'plus-circle',
    'save',
    'search',
    'share-01',
    'sparkle',
    'star',
    'stars-01',
    'stop',
    'thumbs-up',
    'thumbs-up-solid',
    'trash',
    'x-circle',
    'x-close',
    'x-twitter',
] as const;
export type IconName = (typeof iconNames)[number];

export type IconSize = 'xs' | 'sm' | 'md' | 'lg' | 'xl';

@customElement('vm-icon')
export class VmIcon extends LitElement {
    static override styles = Styles;

    @property()
    name!: IconName;

    @property({ reflect: true })
    size: IconSize = 'md';

    private get svg(): string {
        const { name, size } = this;
        if (!name) {
            return '';
        }

        // The small sizes prefer a dedicated 16px asset and fall back to the default one.
        const useSmall = size === 'xs' || size === 'sm';
        const svg = useSmall
            ? (iconModules[`./assets/ic-${name}-16.svg`] ?? iconModules[`./assets/ic-${name}.svg`])
            : iconModules[`./assets/ic-${name}.svg`];
        return svg ?? '';
    }

    override render() {
        return this.svg ? html`${unsafeSVG(this.svg)}` : nothing;
    }
}

declare global {
    interface HTMLElementTagNameMap {
        'vm-icon': VmIcon;
    }
}
